<template>
        <div class="bodyFive">
      <div class="bodyFive_top">
        <div class="title">
          <h3>为您量身打造的全平台服务体系</h3>
          <p>用户版、商户版、微信、小程序 只为满足您个性化使用习惯</p>
        </div>
      </div>
      <div class="bodyFive_bottom">
        <div class="bodyFive_box">
          <div class="bodyFive_box_left">
            <img src="../assets/phone_pic.png" alt="" />
          </div>
          <div class="bodyFive_box_right">
            <div class="bodyFive_right_item one">
              <div class="bodyFive_right_text">
                <h3>用户版</h3>
                <p>
                  适合大众用户使用，支持帮取送、帮买、全能帮、帮排队、代办等业务
                </p>
              </div>
              <div class="bodyFive_right_pic_box">
                <!-- <img src="../assets/five01.png" alt="" />
                <img src="../assets/five02.png" alt="" /> -->
                <img src="../assets/five03.png" alt=""  @click="routerLink('placeOrder')"/>
                <img src="../assets/five04.png" alt="" @click="openCode" />
              </div>
            </div>
            <div class="bodyFive_right_item">
              <div class="bodyFive_right_text two">
                <h3>商户版</h3>
                <p>
                  适合外卖、蛋糕、鲜花、水果、生鲜、3C数码、餐厅店铺使用，支持多店管理，合并顺路单、批量发单、一键发单、取货免打扰、代收货款等功能
                </p>
              </div>
              <div class="bodyFive_right_pic_box">
                <!-- <img src="../assets/five01.png" alt="" />
                <img src="../assets/five02.png" alt="" /> -->
                <img src="../assets/five03.png" alt=""  @click="routerLink('placeOrder')"/>
              </div>
            </div>
          </div>
        </div>

        <img src="../assets/index_five_bg.png" style="width: 100%" alt="" />
      </div>
      <xccCode ref="xccCode" v-if="xccCodeVisible"></xccCode>
    </div>
</template>
<script>
import xccCode from "@/components/xccCode.vue"
export default {
  components: {
    xccCode
  },
  data() {
    return {
      xccCodeVisible:false
    }
  },
  methods: {
    openCode(){
      this.xccCodeVisible = true
      this.$nextTick(()=>{
        this.$refs.xccCode.init()
      })
    },
    routerLink(name) {
      if(name == this.$route.name){
        return
      }
      this.$router.push({
        name: name,
      });
      window.scrollTo(0,0);
    },
  }
}
</script>
<style lang="scss" scoped>
img{
    display: block;
}
.bodyFive {
  padding-top: 90px;
  .bodyFive_top {
    padding-bottom: 150px;
    .title {
      h3 {
        font-size: 32px;
        color: #333333;
        margin: 0;
      }
      p {
        font-size: 20px;
        color: #969696;
        margin: 0;
        margin-top: 30px;
      }
    }
  }
  .bodyFive_bottom {
    position: relative;
    .bodyFive_box {
      position: absolute;
      bottom: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 1380px;
      left: 50%;
      margin-left: -680px;
      .bodyFive_box_left {
        width: 45%;
      }
      .bodyFive_box_right {
        padding-top: 200px;
        width: 55%;
        .bodyFive_right_item {
          .bodyFive_right_text {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            color: #fff;
            align-items: baseline;
            text-align: left;

            h3 {
              font-size: 38px;
              font-weight: bold;
              margin: 0;
              width: 18%;
            }
            p {
              font-size: 16px;
              margin: 0;
              width: 82%;
            }
          }
          .two {
            align-items: center;
          }
          .bodyFive_right_pic_box {
            margin-top: 38px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            img {
              margin-left: 20px;
              cursor: pointer;
            }
            img:first-child {
              margin-left: 0;
            }
          }
        }
        .one {
          margin-bottom: 95px;
        }
      }
    }
  }
}

</style>